import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	fieldsetLabel: {
		id: 'fabric.editor.fieldsetLabel',
		defaultMessage: 'Action Item List',
		description: 'Label for a list of tasks/ action items',
	},
});
